import { ActionIcon, Menu } from '@mantine/core';
import { default as React } from 'react';
import { FaEllipsisV } from 'react-icons/fa';

interface ActionProps {
    leftIcon?: any;
    onClick: (props: { item: any; index: number }) => void;
    title?: any;
    color?: string;
    loading?: (item: any) => boolean;
    disabled?: (item: any) => boolean;
}

const ActionsRender = ({ disabled = false, actions = [], item, index }: { disabled?: boolean; actions: ActionProps[]; item?: any; index?: any }) => {
    return actions.length > 0 &&
        <Menu>
            <Menu.Target>
                <ActionIcon disabled={disabled} variant="light"><FaEllipsisV /></ActionIcon>
            </Menu.Target>
            <Menu.Dropdown style={{ minWidth: 140 }}>
                {actions.map((action, index) => <Menu.Item
                    key={index}
                    color={action.color || "dark"}
                    icon={action.leftIcon}
                    disabled={(
                        (action.loading ? action.loading(item) : false)
                        ||
                        (action.disabled ? action.disabled(item) : false)
                    )}
                    onClick={() => { action.onClick && action.onClick({ item, index }) }}
                >{action.title}</Menu.Item>)}
            </Menu.Dropdown>
        </Menu>
}

export { ActionProps, ActionsRender };